import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HecResponse } from '../../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { CommonHelper } from '../../../../core/_config/common.helper';
import { updateLetterService } from './services/update-letter.service';
import { LoaderService } from '../../../sharedServices/loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SharedService } from '../../../../shared/sharedServices/shared.service';

@Component({
  selector: 'kt-update-letter',
  templateUrl: './update-letter.component.html',
  styleUrls: ['./update-letter.component.css']
})
export class updateLetterComponent implements OnInit {
	headerLogo: string = "./assets/media/logos/logo-2.png";
  public letterText:any;
  public letterList:any;
  public desDegreeId:any;
  public degreeTitle:any;
  public university:any;
  public appId:any;
  public loader:boolean;
  public imageContent:any;
  public imageType:string;
  @ViewChild('letterissueForm',{static:false}) letterissueForm: NgForm;
  model: any = {};
  public leterValue:number;
  letterId: number = null;
  constructor(private dialogRef: MatDialogRef<updateLetterComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private letterIssueService:updateLetterService,private loaderService:LoaderService,
  private cdr:ChangeDetectorRef,private dom:DomSanitizer, public router:Router, 
  private sharedService :SharedService) { }

  async ngOnInit() {
    console.log(this.data)
     await this.getLetterList('des')
      this.appId = this.data.appId;
   
  }

  public async getLetterList(acronym):Promise<void>{
    this.loader = true;
    const res = await this.letterIssueService.getTemplateList(acronym).toPromise();
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.letterList = res.data;
          this.loader=false;
      }else{
        this.loader=false;
        this.cdr.detectChanges();

      }
    
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }



  public getSelectedLetter(value){
    this.loader=true;
    this.letterId = value
    let acronym = 'des'
 
    console.log(this.model)
    this.imageContent = undefined;
    let paylaod = {
      data:{
        desDegreeId:this.data.model.desDegreeId,
        letterId:value,
        degreeTitle:this.data.model.degreeTitle,
        degNameByAdmin:this.data.model.degNameByAdmin,
        university:this.data.model.university,
   

      }}    // this.loaderService.setValue(true);
 
    
    this.letterIssueService.generateLetter(this.appId,paylaod,acronym).subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
      this.loader=false;
      // this.loaderService.setValue(this.loader);
          // this.imageContent = res.data;
          this.imageType = 'pdf'
          this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
          this.cdr.detectChanges();
        }else{
        this.loader=false;
        // this.loaderService.setValue(this.loader);
          this.cdr.detectChanges();
        }
      },
      (err)=>{
          this.loader=false;
          // this.loaderService.setValue(this.loader);
            this.cdr.detectChanges();
          }
    )
  }

  submitLetter():void{
    let payload
    CommonHelper.markFormGroupTouched(this.letterissueForm);
    console.log(this.letterissueForm)
    if(this.validate(this.letterissueForm)){
     
      payload = {
        "id": this.letterissueForm.value.tepmplateId,
        "degreeId": this.data.model.desDegreeId
      }
      console.log(payload)
    

    this.letterIssueService.updateLetter(payload,'des').subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.sharedService.openPopupDialog('Admin', 'Letter has been updated successfully','success')
        this.loader=false;
        this.dialogRef.close(this.letterText)
          this.cdr.detectChanges();
        }else{
          this.sharedService.openPopupDialog('Admin', 'Letter has not been updated successfully','error')
        this.loader=false;
          this.cdr.detectChanges();
        }
      },
      (err)=>{
        this.sharedService.openPopupDialog('Admin', 'Letter has not been updated successfully','error')
          this.loader=false;
            this.cdr.detectChanges();
          }
    )
  }
  

  }


  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

}
